/* ==========================================================================
 *  Open menu
 * ======================================================================= */


function fn_components_open_menu(){
    if ($('.js-open-links').length){
        $(".js-open-links").bind('click', function () {
	        $('.js-open-links').toggleClass("active");
	        $('.js-quick-links-block').slideToggle("linear");
	    });
    }
}

